import React from 'react';

import { colorsPalette } from '../../theme';

const TwitterIcon = (props) => {
  const color = props?.color;
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        id="Icon_awesome-twitter-square"
        data-name="Icon awesome-twitter-square"
        fill={color ? color : colorsPalette.violet}
        d="M21.43,0H2.57A2.57,2.57,0,0,0,0,2.57V21.43A2.57,2.57,0,0,0,2.57,24H21.43A2.57,2.57,0,0,0,24,21.43h0V2.57A2.57,2.57,0,0,0,21.43,0ZM18.81,8.51c0,.15,0,.3,0,.45A9.92,9.92,0,0,1,9,19H8.82a10,10,0,0,1-5.4-1.57,6.12,6.12,0,0,0,.85,0,7,7,0,0,0,4.36-1.5,3.5,3.5,0,0,1-3.28-2.43,3.88,3.88,0,0,0,1.59-.07A3.52,3.52,0,0,1,4.12,10v0a3.43,3.43,0,0,0,1.59.45,3.54,3.54,0,0,1-1.09-4.7,10,10,0,0,0,7.25,3.67,3.52,3.52,0,0,1,6-3.21,6.85,6.85,0,0,0,2.23-.84,3.48,3.48,0,0,1-1.54,1.93,7.17,7.17,0,0,0,2-.54A7.46,7.46,0,0,1,18.81,8.51Z"
      />
    </svg>
  );
};

export default TwitterIcon;
